import {
  FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS,
  FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS_SUCCESS,
  FETCH_ALL_LOAN_BENEFICIARIES_LS,
  FETCH_ALL_LOAN_BENEFICIARIES_LS_SUCCESS,
  MAKE_REQUEST_LOAN_STATUS,
  RESTORE_LOAN_STATUS_INITIAL,
  FETCH_DATA_FOR_PRINTING,
  FETCH_DATA_FOR_PRINTING_SUCCESS,
  ADD_PAYMENT_TO_LOAN_BENEFICIARY,
  ADD_PAYMENT_TO_LOAN_BENEFICIARY_SUCCESS,
  FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID,
  FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID_SUCCESS,
  FETCH_PAYMENT_BY_PAYMENT_ID,
  FETCH_PAYMENT_BY_PAYMENT_ID_SUCCESS,
  EXPORT_LOAN_BENEFICIARIES,
  EXPORT_LOAN_BENEFICIARIES_SUCCESS,
  FETCH_ALL_LOANS_FOR_FILTER,
  FETCH_ALL_LOANS_FOR_FILTER_SUCCESS,
  FETCH_LOAN_BENEFICIARY_BY_ID,
  FETCH_LOAN_BENEFICIARY_BY_ID_SUCCESS
} from "../ActionTypes";


export const fetchTotalLoanBeneficiariesDetails = payload => ({
  type: FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS,
  payload
})

export const fetchTotalLoanBeneficiariesDetailsSuccess = payload => ({
  type: FETCH_TOTAL_LOAN_BENEFICIARIES_DETAILS_SUCCESS,
  payload
})

export const fetchAllLoanBeneficiariesLs = payload => {
  return ({
    type: FETCH_ALL_LOAN_BENEFICIARIES_LS,
    payload
  })
}

export const fetchAllLoanBeneficiariesLsSuccess = payload => ({
  type: FETCH_ALL_LOAN_BENEFICIARIES_LS_SUCCESS,
  payload
})

export const fetchDataForPrinting = payload => ({
  type: FETCH_DATA_FOR_PRINTING,
  payload
})

export const fetchDataForPrintingSuccess = payload => ({
  type: FETCH_DATA_FOR_PRINTING_SUCCESS,
  payload
})

export const addPaymentToLoanBeneficiary = payload => ({
  type: ADD_PAYMENT_TO_LOAN_BENEFICIARY,
  payload
})

export const addPaymentToLoanBeneficiarySuccess = payload => ({
  type: ADD_PAYMENT_TO_LOAN_BENEFICIARY_SUCCESS,
  payload
})

export const fetchPaymentByLoanBeneficiaryId = payload => ({
  type: FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID,
  payload
})

export const fetchPaymentByLoanBeneficiaryIdSuccess = payload => ({
  type: FETCH_PAYMENT_BY_LOAN_BENEFICIARY_ID_SUCCESS,
  payload
})

export const fetchPaymentByPaymentId = payload => ({
  type: FETCH_PAYMENT_BY_PAYMENT_ID,
  payload
})

export const fetchPaymentByPaymentIdSuccess = payload => ({
  type: FETCH_PAYMENT_BY_PAYMENT_ID_SUCCESS,
  payload
})

export const makeRequestLoanStatus = () => ({
  type: MAKE_REQUEST_LOAN_STATUS
})

export const restoreLoanStatusInitial = () => ({
  type: RESTORE_LOAN_STATUS_INITIAL
})

export const exportLoanBeneficiaries = () => ({
  type: EXPORT_LOAN_BENEFICIARIES,
  
})

export const exportLoanBeneficiariesSuccess = payload => ({
  type: EXPORT_LOAN_BENEFICIARIES_SUCCESS,
  payload
})

export const fetchAllLoansForFilter = payload => ({
  type: FETCH_ALL_LOANS_FOR_FILTER,
  payload

})
export const fetchAllLoansForFilterSuccess = payload => ({
  type: FETCH_ALL_LOANS_FOR_FILTER_SUCCESS,
  payload
})

export const fetchLoanBeneficiaryById = payload => ({
  type: FETCH_LOAN_BENEFICIARY_BY_ID,
  payload
})

export const fetchLoanBeneficiaryByIdSuccess = payload => ({
  type: FETCH_LOAN_BENEFICIARY_BY_ID_SUCCESS,
  payload
})